import { S3Client } from '@aws-sdk/client-s3';

const s3 = new S3Client({
  endpoint: process.env.VUE_APP_STORAGE_ENDPOINT,
  region: process.env.VUE_APP_STORAGE_REGION,
  credentials: {
    accessKeyId: process.env.VUE_APP_STORAGE_ACCESS_KEY_ID,
    secretAccessKey: process.env.VUE_APP_STORAGE_SECRET_ACCESS_KEY,
  },
  forcePathStyle: true,
});

export default s3;
